import {configure} from "mobx";
import {createContext, useContext} from "react";
import CardsStore from "./cardsStore";
import WallSettingsStore from "./wallSettingsStore";
import FilterPanelStore from "./filterPanelStore";
import SubjectStore from "./subjectStore";
import YearsStore from "./yearsStore";
import CoCurricularStore from "./coCurricularStore";

configure({enforceActions: 'always'});

export class RootStore {
  cardsStore: CardsStore;
  wallSettingsStore: WallSettingsStore;
  filterPanelStore: FilterPanelStore;
  subjectStore: SubjectStore;
  yearsStore: YearsStore;
  coCurricularStore: CoCurricularStore;

  constructor() {
    this.cardsStore = new CardsStore(this);
    this.wallSettingsStore = new WallSettingsStore(this);
    this.filterPanelStore = new FilterPanelStore(this);
    this.subjectStore = new SubjectStore(this);
    this.yearsStore = new YearsStore(this);
    this.coCurricularStore = new CoCurricularStore(this);
  }
}

export const RootStoreContext = createContext(new RootStore());
export const useStores = () => useContext(RootStoreContext);
